// Libs
import { pipe } from 'fp-ts/lib/function';
import { contramap, ordString } from 'fp-ts/Ord';

export const byContent = pipe(
  ordString,
  contramap((p: { content: string }) => p.content)
);
